import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';
import { Broker, Platform } from '@c4/core';
import { Observable } from 'rxjs';
import { UIModule } from '@c4/ui';
import { SysmanComponentBase,IOnBrokerConnectedInit } from '../sysman/sysman.component';

import { ConnectedDeviceService, VersionsService, DateTimeService } from '../services';
import * as moment from 'moment';

const INPUT_DATE_FORMAT = "YYYY-MM-DD";
const INPUT_TIME_FORMAT = "HH:mm:ss";

@Component({
  selector: 'sysman-time-config',
  templateUrl: './sysman-time-config.component.html',
  styleUrls: ['./sysman-time-config.component.less']
})
export class SysmanTimeConfigComponent extends SysmanComponentBase implements OnInit,IOnBrokerConnectedInit {

  showErrorMsg: boolean;
  initialNtp: string;
  ntp: string;

  initialOtherTimeServer: string;
  otherTimeServer: string;

  initialControllerDateTime: Date;
  controllerDateTime: Date;
  
  address: string;
  secondsTimer: any;
  isSavedServer: boolean;
  isSavedTime: boolean;
  invalidDateTimeMsg: string;

  constructor(private store: Store<any>, private router: Router, private route: ActivatedRoute, 
              private broker: Broker, private platform: Platform,
              private connectedDeviceService: ConnectedDeviceService,
              private versionsService: VersionsService, private dateTimeService: DateTimeService) { 

    super(router, route, store, broker, platform, connectedDeviceService, versionsService);
    super.setBrokerInit(this.onBrokerConnectedInit); // method to call on broker init

    this.showErrorMsg = false;
    this.ntp = "";
    this.initialNtp = "";
    this.otherTimeServer = "";
    this.initialOtherTimeServer = "";
    this.invalidDateTimeMsg = "";
  }

  ngOnInit() {
    this.showErrorMsg = false;
    this.isSavedServer = false;
    this.isSavedTime = false;
    super.OnInit();
  }

  ngOnDestroy() {
    super.destroy();
    if (this.secondsTimer)
      clearInterval(this.secondsTimer);    
  }

  onBrokerConnectedInit() {
    this.connDevice.take(1).subscribe(conn => {
      this.address = conn.connectedDevice.address;
      this.getControllerNTP(((conn.connectedDevice.address != this.brokerHost) ? conn.connectedDevice.address : ""));
      this.getControllerDateTime(((conn.connectedDevice.address != this.brokerHost) ? conn.connectedDevice.address : ""));
    });
  }

  getControllerNTP(address: string) {
    this.connectedDeviceService.setWorking(true);
    this.dateTimeService.getNTPConfig((address!="") ? address : null).then(
        (data:any) => {
              this.showErrorMsg = false;
              // return one of "server", "local", "alt" (not used), or other <addr>
              this.connectedDeviceService.setWorking(false);
              console.log('in getControllerNTP()', data);
              if (data.result && ((data.result.indexOf("ERROR") > -1) || (data.result.indexOf("Invalid ntp argument") > -1)))
                this.showErrorMsg = true;
              else
              if ((data.result != "server") && (data.result != "local")) {
                this.ntp = "";
                this.initialNtp = "";
                this.otherTimeServer = data.result;
                this.initialOtherTimeServer = this.otherTimeServer;
              }
              else {
                this.ntp = data.result;
                this.initialNtp = data.result;
                this.otherTimeServer = "";
                this.initialOtherTimeServer = "";
              }
            },
            (err:any) => {
              this.connectedDeviceService.setWorking(false);
              console.error('getControllerNTP() error: ', err);
    });
  }

  onSaveControllerNTP() {
    console.log("onSaveControllerNTP()", this.ntp);
    this.connectedDeviceService.setWorking(true);
    this.isSavedServer = false;

    this.dateTimeService.setNTPConfig(this.ntp, this.otherTimeServer, ((this.address != this.brokerHost) ? this.address : null)).then(
        (data:any) => {
              this.connectedDeviceService.setWorking(false);
              console.log('in onSaveControllerNTP()', data); 
              this.initialOtherTimeServer = this.otherTimeServer;
              this.isSavedServer = true;
              this.initialNtp = this.ntp;
            },
            (err:any) => {
              this.connectedDeviceService.setWorking(false);
              console.error('onSaveControllerNTP() error: ', err);
              this.isSavedServer = false;
    });
  }

  getControllerDateTime(address: string) {
    this.connectedDeviceService.setWorking(true);

    this.dateTimeService.getDateTime(((address != "") ? address : null)).then(
        (data:any) => {
              this.connectedDeviceService.setWorking(false);
              console.log('in getControllerDateTime()', data); 
              // "date": "2017-01-20T18:47:15.000Z"
              this.controllerDateTime = new Date(data.date);
              this.initialControllerDateTime = new Date(data.date);
              //this.secondsTimer = setInterval(() => {
              //  this.controllerDateTime = new Date(this.controllerDateTime.getTime() + 1000);
              //}, 1000);
            },
            (err:any) => {
              this.connectedDeviceService.setWorking(false);
              console.error('getControllerDateTime() error: ', err);
      });
  }

  onSaveControllerDateTime() {
    console.log("onSaveControllerDateTime()", this.controllerDateTime.toISOString());
    this.connectedDeviceService.setWorking(true);
    this.isSavedTime = false;

    let putData: any = {};
    if (this.address != this.brokerHost)
      putData['ip'] = this.address;

    putData['date'] = this.controllerDateTime.toISOString();
    var request: any = {
      method: 'PUT',
      path: '/api/v1/sysman/date',
      data: putData
    };
    this.broker.call(request).then(
        (data:any) => {
              this.connectedDeviceService.setWorking(false);
              console.log('in onSaveControllerDateTime()', data); 
              this.isSavedTime = true;
              this.getControllerDateTime(this.address);
            },
            (err:any) => {
              this.connectedDeviceService.setWorking(false);
              console.error('onSaveControllerDateTime() error: ', err);
              this.isSavedTime = false;
            });
  }

  validateDate(date : any) {
    this.invalidDateTimeMsg = "";
    if (moment(date, INPUT_DATE_FORMAT).isValid()) {
      let newDate : Date = moment(date, INPUT_DATE_FORMAT).toDate();
      this.controllerDateTime = new Date(
        newDate.getFullYear(),
        newDate.getMonth(),
        newDate.getDate(),
        this.controllerDateTime.getHours(),
        this.controllerDateTime.getMinutes(),
        this.controllerDateTime.getSeconds());
    }
    else {
      console.log("validateDate(): Not a valid date:", date);
      this.invalidDateTimeMsg = "Please enter a valid date";
    }
  }

  validateTime(time : any) {
    this.invalidDateTimeMsg = "";
    if (moment(time, INPUT_TIME_FORMAT).isValid()) {
     this.controllerDateTime = new Date(
        this.controllerDateTime.getFullYear(),
        this.controllerDateTime.getMonth(),
        this.controllerDateTime.getDate(),
        moment(time, INPUT_TIME_FORMAT).hour(),
        moment(time, INPUT_TIME_FORMAT).minute(),
        moment(time, INPUT_TIME_FORMAT).second());
    }
    else {
      console.log("validateDate(): Not a valid time:", time);
      this.invalidDateTimeMsg = "Please enter a valid time";
    }
  }
}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/sysman-time-config/sysman-time-config.component.ts